import { useEffect, useState } from "react";
import { completeSetupInvite, getSetupInvite } from "../api/registration";
import { getErrorMessage } from "../utils/apiErrors";
import { storeUser } from "../utils/session";
import PublicFooter from "../components/PublicFooter";
import PageMetadata from "../components/PageMetadata";

function persistSession(res) {
  storeUser(res.user);
}

export default function SetupAccount() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [invite, setInvite] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    async function load() {
      try {
        const res = await getSetupInvite(token);
        setInvite(res.data);
      } catch (err) {
        setError(getErrorMessage(err, "Invalid or expired setup invite."));
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      const res = await completeSetupInvite({
        token,
        password,
        password_confirmation: passwordConfirmation,
      });

      persistSession(res);

      if (res.mfa_setup_required) {
        window.location.href = "/mfa/setup";
        return;
      }

      if (res.user?.is_demo && res.user?.demo_mfa_exempt) {
        window.location.href = "/app/demo";
        return;
      }

      window.location.href = "/login";
    } catch (err) {
      setError(getErrorMessage(err, "Unable to complete setup."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="login-page">
      <PageMetadata title="Set Up Account | CounselVault" description="Complete secure setup for an invited CounselVault account." path="/setup-account" />
      <div className="login-card">
        <div className="d-flex align-items-center gap-3 mb-4">
          <div className="brand-mark">CV</div>
          <div>
            <h4 className="mb-0">Complete Account Setup</h4>
            <div className="text-muted small">CounselVault</div>
          </div>
        </div>
        {loading ? (
          <div className="text-muted">Loading invite...</div>
        ) : error && !invite ? (
          <div className="alert alert-warning py-2">{error}</div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <h2 className="fw-bold mb-1">Set Your Password</h2>
              <div className="text-muted">{invite?.name} · {invite?.email}</div>
            </div>

            {error && <div className="alert alert-warning py-2">{error}</div>}

            <div className="mb-3">
              <label className="form-label">Password</label>

              <input
                type="password"
                className="form-control form-control-lg"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength="12"
                required
              />

              <div className="form-text">
                Password must be at least 12 characters and include uppercase, lowercase, number, and symbol.
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label">Confirm Password</label>

              <input
                type="password"
                className="form-control form-control-lg"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                minLength="12"
                required
              />
            </div>

            <button
              className="btn btn-dark btn-lg w-100"
              disabled={saving}
            >
              {saving ? "Saving..." : "Set Password"}
            </button>
          </form>
        )}
      </div>
      <PublicFooter />
    </div>
  );
}
